import { getTagsOptions, getTagsQueryKey } from "@/client/@tanstack/react-query.gen";
import { readCache } from "@/store/action";
import type { GetTagsResponse } from "@/client/types.gen";

export type ApiTag = GetTagsResponse[number];

export const useTagsOptions = () => getTagsOptions();

export function getTags(): GetTagsResponse | undefined {
  return readCache<ReturnType<typeof getTagsQueryKey>, GetTagsResponse>(
    getTagsQueryKey()
  );
}

export function getTagById(id: number): ApiTag | undefined {
  const tags = getTags();
  return tags?.find(t => t.id === id);
}
